var $da3ce82ad291e297$exports = {};
$da3ce82ad291e297$exports = {
    "decrease": (args)=>`${args.fieldLabel} \u{AC10}\u{C18C}`,
    "increase": (args)=>`${args.fieldLabel} \u{C99D}\u{AC00}`,
    "numberField": `\u{BC88}\u{D638} \u{D544}\u{B4DC}`
};


export {$da3ce82ad291e297$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
